import axios from 'axios';
import {
  CaseConstructionLegalityDocumentAddFormModel,
  CaseConstructionLegalityModel
} from 'app/edozvola/cases/case-construction-legality/model/case-construction-legality.model';

const caseBaseUrl = '/api/cases';

export const saveCaseConstructionLegality = async (idCase: string, values: CaseConstructionLegalityModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/construction-legality`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseConstructionLegality = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/construction-legality`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const fetchCaseConstructionLegalityDocument = async ({ idCase, webId }): Promise<CaseConstructionLegalityDocumentAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`${caseBaseUrl}/${idCase}/construction-legality/documents/${webId}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const fetchSavedCaseConstructionLegalityDocument = async ({
                                                                   idCase,
                                                                   idCaseConstructionLegalityDocumentMap,
                                                                 }): Promise<CaseConstructionLegalityDocumentAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`${caseBaseUrl}/${idCase}/construction-legality/documents/saved/${idCaseConstructionLegalityDocumentMap}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const deleteCaseConstructionLegalityDocument = async (idCase, webId): Promise<CaseConstructionLegalityDocumentAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`${caseBaseUrl}/${idCase}/construction-legality/documents/${webId}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const saveCaseConstructionLegalityDocument = async (
  idCase: string,
  document: CaseConstructionLegalityDocumentAddFormModel,
): Promise<CaseConstructionLegalityDocumentAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/construction-legality/documents`, document)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const fetchCaseConstructionLegalityDocuments = async ({
                                                               signal,
                                                               pagination,
                                                               idCase,
                                                             }): Promise<CaseConstructionLegalityDocumentAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `${caseBaseUrl}/${idCase}/construction-legality/documents?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};
